<template>
    <div class="body">
        <div v-for="(item) of placeholderList" :key="item" class="item"/>
    </div>
</template>

<script setup>
const placeholderList = ref([1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]);
</script>

<style scoped lang="scss">
.body {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
    gap: 26px;
    grid-auto-rows: minmax(100px, auto);
    .item {
        aspect-ratio: 2/ 3;
        background: #f4f5f6;
        border-radius: 10px;
    }
    @include responseTo(web-1134px) {
        grid-template-columns: repeat(3, 1fr);
    }
    @include responseTo(web-799px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 14px;
    }
}
</style>
